// extracted by mini-css-extract-plugin
export default {"account":"account__2AYt_","createAccount":"createAccount__3U3v3","login":"login__2SDco"};